import { render } from "./LocalWorkExperience.vue?vue&type=template&id=1b985be5&scoped=true&ts=true"
import script from "./LocalWorkExperience.vue?vue&type=script&lang=ts"
export * from "./LocalWorkExperience.vue?vue&type=script&lang=ts"

import "./LocalWorkExperience.vue?vue&type=style&index=0&id=1b985be5&scoped=true&lang=css"

import exportComponent from "/home/bwhite/Projects/bryanchriswhite-com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b985be5"]])

export default __exports__